const PRODUCT_PROOFENGINE_PICKPACK = "8",
      ORDER_SOURCE_OIA             = "OIA";

export const isOiaItem = item => item.source === ORDER_SOURCE_OIA && item.proofEngineType !== PRODUCT_PROOFENGINE_PICKPACK;
